module.exports = __webpack_public_path__ + "static/media/nodesdemo.945a5e47.png";